import rootEmailsSaga from "./emails"


export const rootSaga = {
  rootEmailsSaga: rootEmailsSaga
}